import React, { useContext, useEffect, useState, createRef } from 'react'
import {
  selectCurrentPage,
  selectTotalPages,
  setTotalPages,
} from '../redux/viewer-slice'
import { useDispatch, useSelector } from 'react-redux'
import { DocumentViewerContext } from '../contexts/document-viewer-instance-context'
import { useParams } from 'react-router-dom'
import { selectCurrentDocument } from '../redux/application-slice'

const PageCount: React.FC = () => {
  const totalPages = useSelector(selectTotalPages)
  const documentViewerContext = useContext(DocumentViewerContext)
  const currentDocument = useSelector(selectCurrentDocument)
  const { documentViewer } = documentViewerContext
  const currentPage = useSelector(selectCurrentPage)
  const { documentId } = useParams<{ documentId: string }>()
  const dispatch = useDispatch()

  const [page, setPage] = useState(currentPage)
  const ref = createRef<HTMLInputElement>()

  useEffect(() => {
    setPage(currentPage)
  }, [currentPage])

  useEffect(() => {
    dispatch(setTotalPages(1))
  }, [currentDocument, dispatch])

  const onPageChange = (event) => {
    setPage(event.target.value)
  }

  const onPressEnter = (event) => {
    if (event.key === 'Enter') {
      documentViewer?.setCurrentPage(parseInt(page), false)
      ref?.current?.blur()
    }
  }

  return (
    <div
      className={
        'relative ml-4 flex items-center gap-2 rounded-lg border-2 border-[#ffffff00] bg-[#f1f5fa] px-2 py-1 shadow-sm transition-colors hover:border-2 hover:border-blue-500 hover:!bg-[#fff]'
      }
    >
      <div>
        <input
          disabled={currentDocument ? !currentDocument?.id : !documentId}
          ref={ref}
          max={totalPages}
          min={1}
          onChange={onPageChange}
          onKeyUp={onPressEnter}
          className={
            'cursor-select w-8 rounded-lg border-0 border-2 border-[#ffffff00] bg-[#ffffff00] p-0 text-center opacity-75 hover:border-2 hover:border-blue-700 focus:bg-none focus:outline-none active:!border-0 active:border-0 active:!border-[#ffffff00]'
          }
          type="text"
          value={page}
        />
      </div>
      <div className="whitespace-nowrap">/ {totalPages}</div>
    </div>
  )
}

export default PageCount
